import styled from '@emotion/styled';
import { useMemo } from 'react';

import { ProfileIcon } from '@app-velocity/icons';

import { LEGACY_PERSONAS } from '../../constants';

export type PersonaAvatarProps = {
  name: string;
};

const StyledAvatar = styled('div')<{ color: string }>(({ color }) => ({
  borderRadius: 4,
  fontWeight: 500,
  height: 22,
  width: 22,
  color: '#fff',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: color,
  flex: '0 0 auto',
  svg: {
    fill: '#fff !important',
  },
}));

const hashString = (value: string) => {
  let hash = 0;

  for (let index = 0; index < value.length; index += 1) {
    hash = value.charCodeAt(index) + ((hash << 5) - hash);
  }

  return Math.abs(hash);
};

const getCustomPersonaColor = (value: string) => {
  const hue = hashString(value) % 360;

  return `hsl(${hue} 55% 45%)`;
};

export const PersonaAvatar = ({ name }: PersonaAvatarProps) => {
  const color = useMemo(() => {
    switch (name) {
      case 'default':
        return 'var(--button-button-primary-color)';
      case 'accessible':
        return '#e95733';
      default:
        if (LEGACY_PERSONAS.includes(name as (typeof LEGACY_PERSONAS)[number])) {
          return 'var(--button-button-primary-color)';
        }

        return getCustomPersonaColor(name);
    }
  }, [name]);

  return (
    <StyledAvatar color={color}>
      <ProfileIcon />
    </StyledAvatar>
  );
};
